<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Career Opportunities at Innovative Vision</h2>
        <!-- <h3>Nurturing Every Child's Unique Potential</h3> -->
        <p>
          Are you a passionate and empathetic professional looking to make a difference in children's lives?
          Join our mission to foster holistic growth in young minds. At Innovative Vision, we are more than just
          an organization; we are a community dedicated to shaping the next generation of well-rounded individuals.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/careerH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>
<!-- <div class="frame-31655_9529-1708"> -->
  <div class="row m-1">
    <div class="col-md-6 col-12">
      <div class="gemini-generated-image-2hkjt62hkjt62hkj-photoroom-1_9523-1693">
        <img src="assets/ivimg/career1.svg" alt="Why Work With Us" />
      </div>
    </div>
    <div class="col-md-6 col-12 mt-1">
      <div class="frame-31653_9523-1690">
        <span class="text-why-work-with-us-_9523-1688">Why Work With Us?</span>
        <span class="text-content">
          <b>A Culture of Growth:</b> We believe in continuous learning and
          professional development. We provide regular "Train the Trainers" programs
          to keep our team in sync with the latest methodologies and best practices.
          <br/><br/>
          <b>Impactful Work:</b> Your work directly contributes to a child's
          confidence, discipline, and emotional well-being. We don't just teach
          skills; we help build a lifestyle of discipline, creativity, and joy.
          <br /><br />
          <b>Holistic Philosophy:</b> Our unique approach focuses on the mind, body,
          and soul, allowing you to be part of a truly comprehensive educational
          model.
          <br /><br />
          <b>Supportive Environment:</b> We are a team of experienced, certified,
          and passionate individuals who support each other in achieving our shared
          goals.
        </span>
      </div>
    </div>
  </div>
<!-- </div> -->
<div class="contact-wrapper">
  <div class="contact-form">
    <h2>Application Form</h2>
    <!-- ✅ FormGroup should be on the <form> tag -->
    <form [formGroup]="applicationForm" (ngSubmit)="onSubmit()">
      <!-- Name -->
      <input type="text" 
             class="form-control" 
             formControlName="name" 
             placeholder="Enter Your Name / School Name *"/>
      <div class="text-danger" *ngIf="f['name'].invalid && (f['name'].touched || submitted)">
        Name is required (min 3 chars).
      </div>
      <div class="row mt-2">
        <!-- Contact -->
        <div class="col-12 col-md-6">
          <input type="text" 
                 class="form-control" 
                 formControlName="contact" 
                 placeholder="Enter Your Contact No. *"/>
          <div class="text-danger" *ngIf="f['contact'].invalid && (f['contact'].touched || submitted)">
            Enter a valid 10-digit number.
          </div>
        </div>
        <!-- Email -->
        <div class="col-12 col-md-6">
          <input type="email" 
                 class="form-control" 
                 formControlName="email" 
                 placeholder="Enter Your Email ID *"/>
          <div class="text-danger" *ngIf="f['email'].invalid && (f['email'].touched || submitted)">
            Enter a valid email.
          </div>
        </div>
      </div>
      <!-- Applying For -->
      <input type="text" 
             class="form-control mt-2" 
             formControlName="applyingFor" 
             placeholder="Applying For *"/>
      <div class="text-danger" *ngIf="f['applyingFor'].invalid && (f['applyingFor'].touched || submitted)">
        Please specify what you are applying for.
      </div>
      <!-- Resume -->
      <input type="file" 
             class="form-control mt-2" #fileInput
             (change)="onFileSelected($event)" 
             accept=".pdf,.doc,.docx"/>
      <div class="text-danger" *ngIf="f['attachResume'].invalid && (f['attachResume'].touched || submitted)">
        Resume is required.
      </div>
      <!-- About -->
      <textarea class="form-control mt-2" 
                formControlName="yourself" 
                placeholder="Write About Yourself"></textarea>
      <div class="text-danger" *ngIf="f['yourself'].invalid && (f['yourself'].touched || submitted)">
        Please write at least 10 characters about yourself.
      </div>
      <!-- Submit -->
      <button type="submit" 
              class="btn btn-primary mt-3"
              >
        Send
      </button>
    </form>
  </div>
</div>
<div class="how-to-apply">
  <h2 class="apply-title">How to Apply</h2>
  <div class="apply-content">
    <p>
      If you are a passionate and certified professional with a strong interest
      in child development, we encourage you to send your resume to:
    </p>
    <p class="apply-email">careers@innovativevision.com</p>
    <p>
      Please mention the position you are applying for in the subject line. We
      look forward to hearing from you and potentially welcoming you to the
      Innovative Vision family!
    </p>
  </div>
</div>